var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79134 17.4163H7.33301C3.66634 17.4163 1.83301 16.4997 1.83301 11.9163V7.33301C1.83301 3.66634 3.66634 1.83301 7.33301 1.83301H14.6663C18.333 1.83301 20.1663 3.66634 20.1663 7.33301V11.9163C20.1663 15.583 18.333 17.4163 14.6663 17.4163H14.208C13.9238 17.4163 13.6488 17.5538 13.4747 17.783L12.0997 19.6163C11.4947 20.423 10.5047 20.423 9.89967 19.6163L8.52467 17.783C8.37801 17.5813 8.03884 17.4163 7.79134 17.4163Z",
    stroke: "#505054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6634 10.083H14.6725M10.9958 10.083H11.0049M7.3291 10.083H7.33644",
    stroke: "#505054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a6e4a6cff3035148631d95e1a6940e76.svg";
export { ForwardRef as ReactComponent };